import { TradeKeyContext } from '@/contexts/trade-key-context';
import { useContext } from 'react';

const useTradeKey = () => {
  const values = useContext(TradeKeyContext);
  return values;
};

export default useTradeKey;
